export const messages = [
  {
    id: 1,
    name: "Mehmet Yıldırım",
    email: "mehmet.yildirim@gmail.com",
    phone: "0532 441 87 23",
    subject: "Yenigül Park Suites hakkında bilgi almak istiyorum",
    message: "Bursa Nilüfer'deki projenize çok ilgi duyuyorum. 3+1 daire seçenekleri ve ödeme planları hakkında detaylı bilgi alabilir miyim? Ailecek ziyaret etmek istiyoruz.",
    date: "2026-04-18",
    status: "new",
    project: "Yenigül Park Suites"
  },
  {
    id: 2,
    name: "Ayşe Kaya",
    email: "aysekaya@outlook.com",
    phone: "0555 312 09 44",
    subject: "Yatırım amaçlı daire sorusu",
    message: "Merhaba, yatırım amaçlı bir daire almayı düşünüyorum. Hangi projelerinizde en yüksek kira getirisi bekleniyor? Özellikle İstanbul ve İzmir projelerinize odaklanmak istiyorum.",
    date: "2026-04-17",
    status: "read",
    project: "Genel"
  },
  {
    id: 3,
    name: "Kemal Arslan",
    email: "kemal.arslan@arslanyatirim.com",
    phone: "0212 567 34 90",
    subject: "Kurumsal ortaklık teklifi",
    message: "Arslan Yatırım A.Ş. olarak büyük ölçekli bir proje için ortak yatırımcı arıyoruz. Yenigül ile ortak geliştirme modeli üzerine bir görüşme talep ediyoruz.",
    date: "2026-04-15",
    status: "replied",
    project: "Kurumsal"
  },
  {
    id: 4,
    name: "Selin Öztürk",
    email: "selin.ozturk@hotmail.com",
    phone: "0541 789 22 65",
    subject: "Marina Living - teslimat tarihi sorgulama",
    message: "İzmir Marina Living'de dairem bulunuyor. Anahtar teslim tarihine dair son güncellemeleri öğrenmek istiyorum. Sözleşmemde Mart 2024 yazıyor ancak hâlâ bilgi almadım.",
    date: "2026-04-14",
    status: "replied",
    project: "Yenigül Marina Living"
  },
  {
    id: 5,
    name: "Hasan Demir",
    email: "hdemir@demirinsaat.net",
    phone: "0322 445 67 12",
    subject: "Alt yüklenici teklif sunumu",
    message: "Demir İnşaat Elektrik olarak projelerinizde elektrik tesisat alt yüklenicisi olmak istiyoruz. Fiyat teklifimizi sunmak için uygun bir zaman belirleyebilir miyiz?",
    date: "2026-04-12",
    status: "new",
    project: "Genel"
  },
  {
    id: 6,
    name: "Fatma Şahin",
    email: "fatmasahin55@gmail.com",
    phone: "0507 334 88 01",
    subject: "Panorama Residence - garanti belgesi talebi",
    message: "Kadıköy Panorama Residence sakiniyim. Isıtma sistemi için Bosch garantisine ait belgeleri talep ediyorum. Bakım servisim için gerekli.",
    date: "2026-04-10",
    status: "read",
    project: "Yenigül Panorama Residence"
  },
  {
    id: 7,
    name: "Can Erdoğan",
    email: "can.erdogan@teknoyapi.com",
    phone: "0216 890 54 33",
    subject: "Green Valley projesinde villa rezervasyonu",
    message: "Antalya Green Valley projesi için pre-satış kapsamında villa rezervasyonu yapmak istiyorum. Ön ödeme ve iptal koşullarını öğrenebilir miyim?",
    date: "2026-04-09",
    status: "new",
    project: "Yenigül Green Valley"
  },
  {
    id: 8,
    name: "Rüya Kılıç",
    email: "ruya.kilic@mimarlikbureau.com",
    phone: "0312 556 22 78",
    subject: "Mimari proje ortaklığı",
    message: "Ankara merkezli mimarlık bürosu olarak Yenigül'ün yeni projelerinde tasarım danışmanı olarak yer almak istiyoruz. Portföyümüzü sunarız.",
    date: "2026-04-07",
    status: "replied",
    project: "Kurumsal"
  }
];

export const messageStats = {
  total: 8,
  newCount: 3,
  readCount: 2,
  repliedCount: 3
};
